// extracted by mini-css-extract-plugin
module.exports = {"sectionWordCloud":"_75a5f581 f4 fw6 fl db pv1 ma1 black-70 link hover-black animate"};